import React, { useState } from "react";
import { SendFormData } from "../backend/ServerFuctions.js";

function RequestQuote() {
  const [serverMsg, setServerMsg] = useState("");
  const formReset = {
    name: "",
    email: "",
    telephone: "",
  };
  const [form, setState] = useState(formReset);

  const updateField = (e) => {
    setServerMsg("");
    setState({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (form.name !== "" && form.email !== "" && form.telephone !== "") {
      SendFormData(form, "../backend/contact-us.php").then((data) => {
        if (data.status === "success") {
          setState(formReset);
        }
        setServerMsg(data.message);
        setTimeout(() => {
          setServerMsg("");
        }, 3500);
      });
    } else {
      setServerMsg("Please fill in all fields marked with *");
      setTimeout(() => {
        setServerMsg("");
      }, 3500);
    }
  };

  return (
    <section className="quote-section">
      <div className="container form-container">
        <div className="row">
          <div className="col-12">
            <div className="d-flex flex-column align-items-center content-heading text-white text-center pt-5">
              Get a free quotation
            </div>
            <div className="content-subheading text-white text-center pb-4">
              Send us a Request. One of our sales represetative will contact you
              as soon as possible.
            </div>
            {serverMsg !== "" && (
              <div className="col-12 font-weight-bold py-2 form-state text-center">
                <small>{serverMsg}</small>
              </div>
            )}
            <div className="d-flex justify-content-center flex-wrap">
              <form className="pb-1" onSubmit={handleSubmit} method="POST">
                <div className="form-row pb-4">
                  <div className="col-12 col-md-3 pb-2">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Name:*"
                      value={form.name}
                      onChange={updateField}
                      required
                    />
                  </div>
                  <div className="col-12 col-md-3 pb-2">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Email:*"
                      value={form.email}
                      onChange={updateField}
                      required
                    />
                  </div>
                  <div className="col-12 col-md-3 pb-2">
                    <input
                      type="text"
                      name="telephone"
                      className="form-control"
                      placeholder="Tel:* 079-000-0000"
                      value={form.telephone}
                      onChange={updateField}
                      pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                      required
                    />
                    <small className="text-white">Format: 079-000-0000</small>
                  </div>
                  <div className="col-12 col-md-3 pb-2">
                    <button type="submit" className="btn btn-primary mb-2">
                      Send Request
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default RequestQuote;
